const page = require('page');
const { isHostedLink } = require('utilities/urlUtilities');
const analyticsUtilities = require('utilities/analyticsUtilities');
const { OUTBOUND_LINK } = analyticsUtilities.events;

const tgHost = {
	'about.readworks.org': true
};

module.exports = {
	onWeeblyLinkClick(anchor, rootPath, newWindow) {
		const href = anchor ? anchor.getAttribute('href') : null;
		if (href) {
			const url = new URL(anchor.href);
			const pathname = url.pathname;
			const search = url.search || '';
			const hash = url.hash || '';
			const hosted = isHostedLink(href);
			const host = url.host;

			let launchExternal = false;

			if (hosted || tgHost[host]) {
				if (pathname && pathname.indexOf('/uploads/') === 0) {
					// Weebly File upload
					launchExternal = true;
					window.open('//about.readworks.org' + href, '_blank');
				} else if ((tgHost[url.host] || (href && href.indexOf('/') === 0)) && pathname.indexOf('/blog') !== 0) {
					// If link is about.readworks.org OR a relative path, but NOT a blog link
					// Weebly Links
					let constructedUrl = rootPath + pathname + search + hash;
					if (rootPath.replace('/', '') === pathname.replace('/', '')) {
						constructedUrl = rootPath + search + hash;
					}
					if (hash.indexOf('new-window') !== -1 || newWindow) {
						window.open(constructedUrl, '_blank');
					} else {
						page.show(constructedUrl);
					}
				} else if (hosted) {
					// Web App link
					let constructedUrl = pathname + search + hash;
					if (hash.indexOf('new-window') !== -1 || newWindow) {
						window.open(constructedUrl, '_blank');
					} else {
						page.show(constructedUrl);
					}
				} else {
					launchExternal = true;
					window.open(href, '_blank');
				}
			} else {
				launchExternal = true;
				window.open(href, '_blank');
			}

			if (launchExternal && anchor && href) {
				analyticsUtilities.fireEvent(OUTBOUND_LINK, {
					path: href
				});
			}
		}
	}
};
